export enum PlatformEnum {
  TSX = 'tsx',
  APP_NAME = 'tsx-ui',
  INSPIRATION = 'inspiration',
  PINKPEOPLE = 'pinkpeople',
  COVIDMAP = 'covidmap',
  APP = 'tsx_app',
}
